import { PendingStatus } from '@components'
import { ApprovalResult } from '@global/types'

export interface PendingRow {
  can_delete: boolean
  created_by_id: number
  has_pending_rows: boolean
  id: number
  uuid: string
  identifier?: string
  name?: string
  number_of_rows?: number
  template_id?: number
  template_name?: string
  type: PendingStatus
  updated_at?: string
  last_updated?: string
  created_by_name?: string
  status?: PendingStatus
  source?: string
  row_count?: number
  approval_result?: ApprovalResult | null
  dataset_id?: number
}

export enum PendingRowTypeDisplayText {
  'Approved' = 'Processing',
  'Pending' = 'Processing',
  'Awaiting Approval' = 'Awaiting Approval',
  'Draft' = 'Draft',
  'Error' = 'Paused - With Errors',
  'Paused' = 'Paused - Pending Review',
  'Rejected' = 'Awaiting Approval - Rejected',
  'Shared Draft' = 'Shared Draft',
  'Warning' = 'Warning',
}

export enum PendingTypeOptions {
  'Awaiting Approval' = 'Awaiting Approval',
  'Draft' = 'Draft',
  'Error' = 'Paused - With Errors',
  'Paused' = 'Paused - Pending Review',
  'Shared Draft' = 'Shared Draft',
}
